import { Box, styled, Typography } from '@mui/material';

export const CheckboxContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
}));

export const CheckboxText = styled(Typography)(({ theme, disabled }) => ({
  fontSize: '12px',
  fontWeight: 500,
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: disabled
    ? theme.palette.colors.secondaryDisabledText
    : theme.palette.colors.onSecondaryAndDetailBackground,
}));
